import { Inventory, ProductInventories } from '../model';

export const productsInventoriesToInventories = (
  productId: string,
  materialId: string | null,
) => (productsInventories: ProductInventories[]): Inventory[] =>
  productsInventories
    // even if we provide exact sellable productId, endpoint returns all options of the product
    // for the cbasket we want to know inventories of the exact sellable items
    .filter(
      (item) => item.productId === productId || item.productId === materialId,
    )
    .map((item) => item.inventories)
    .flat();
